export default __webpack_public_path__ + "assets/front/scss/user-profile.e4d0ea88993833969fd4602bd39f3e0c.css";